












































import { Component,	Vue } from 'vue-property-decorator';

import { bus } from '@/main'
import GlobalMixins from '@/mixins'
import { Languages } from '@/enums'

@Component
export default class Start extends GlobalMixins {
	backgrounds: string[] = [
		'/gfx/img/backgrounds/background-2.jpeg',
		'/gfx/img/backgrounds/background-teacher.jpg',
		'/gfx/img/backgrounds/background-douane.jpg',
		'/gfx/img/backgrounds/background-factory.jpg',
		'/gfx/img/backgrounds/background-group.jpg',
		'/gfx/img/backgrounds/background-worker.jpeg'
	]
	currentBackground: number = -1;
	backgroundsIntervalIsActive: boolean = true;
	backgroundsInterval: any;

	toggleInfo(): void {
		bus.$emit('toggleInfo')
	}
	start(): void {
		this.$router.push({ name: this.language === Languages.NL ? 'select-age' : 'select-age-'+this.language })
	}

	togglePauseBackground(): void {
		this.backgroundsIntervalIsActive = !this.backgroundsIntervalIsActive;
	}

	resetBackground(): void {
		this.currentBackground = 0
	}

	playBackground(): void {
		this.backgroundsInterval = setInterval(() => {
			if(this.backgroundsIntervalIsActive) {
				this.currentBackground = this.currentBackground === (this.backgrounds.length - 1) ? 0 : (this.currentBackground + 1)
			}
		}, 4500)
	}

	mounted() {
		this.currentBackground = Math.round(Math.random() * (this.backgrounds.length - 1))
		if(this.backgroundsIntervalIsActive) {
			this.playBackground()
		}
	}
}
